module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am481-6c7a380d20281f4ce232aa42b3d5c676.jpg";